export default {
  label: {
    header: {
      title: 'Dashboards',
      button: 'Criar dashboard',
      subtitle: 'Crie dashboards, edite os que já foram criados ou faça buscas com os filtros abaixo.',
      input: {
        placeholder: 'Buscar dashboard',
      },
    },
    table: {
      accountId: 'Id da conta',
      universeId: 'Id da pesquisa',
      dashboardId: 'Id do dashboard',
      title: 'Título do dashboard',
      trialDate: 'Data do trial',
      environment: 'Ambiente',
      users: 'Usuários com acesso',
    },
    filter: {
      accountId: 'ID da conta',
      universeId: 'ID da pesquisa',
      dashboardId: 'ID do dashboard',
      users: 'Usuário',
      contract: 'Modelo de contrato',
      env: 'Ambiente',
      published: 'Compartilhamento',
      title: 'Título do dashboard',
      createDate: 'Data de criação',
      lastUpdateDate: 'Última atualização'
    },
    button: {
      applyButton: 'Aplicar',
      cancelButton: 'Cancelar',
      clearButton: 'Limpar tudo',
      tryAgainButton: 'Tentar novamente',
    },
    message: {
      error: {
        dashboard: 'Máximo de 20 caracteres.',
      },
      dataLoadingError: {
        title: 'Erro no carregamento',
        description: 'Houve uma falha no carregamento dos dados. Por favor, tente novamente.'
      },
      noDataFinding: {
        title: 'Não há resultados para a sua filtragem',
        description: 'Tente uma combinação diferente de filtros para ter resultados',
      }
    }
  },
  notification: {
    loadingData: 'Carregando dados...',
  }
};
